import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Pencil, Save, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { useEmailCheck, EmailCheckHint } from '../EmailCheckHint';
import { useAuth } from '../../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const split = (full = '') => { const p = full.trim().split(/\s+/); return p.length > 1 ? [p.slice(0, -1).join(' '), p[p.length - 1]] : [p[0] || '', '']; };

// Profil: kullanıcı kendi ad, soyad, e-posta ve telefonunu değiştirir
export const ProfileEditForm = ({ onClose }) => {
  const { user, refreshUser } = useAuth();
  const [first, last] = split(user?.name);
  const [form, setForm] = useState({ first, last, email: user?.email || '', phone: user?.phone || '' });
  const [saving, setSaving] = useState(false);
  const emailCheck = useEmailCheck(form.email, { original: user?.email, excludeUserId: user?.id });
  const set = (k) => (e) => setForm(prev => ({ ...prev, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    if (!form.first.trim() || !form.last.trim()) { toast.error('Ad ve soyad zorunludur'); return; }
    setSaving(true);
    try {
      await axios.put(`${API}/auth/profile`, { name: `${form.first.trim()} ${form.last.trim()}`, email: form.email.trim(), phone: form.phone.trim() || null });
      const emailChanged = form.email.trim().toLowerCase() !== (user?.email || '').toLowerCase();
      toast.success('Bilgileriniz güncellendi', emailChanged ? { description: `Bundan sonra ${form.email.trim()} ile giriş yapacaksınız.`, duration: 8000 } : undefined);
      await refreshUser();
      onClose();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Geçerli bir e-posta adresi girin');
    } finally { setSaving(false); }
  };
  return (
    <form onSubmit={save} className="space-y-4" data-testid="profile-edit-form">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div><Label htmlFor="pf-first">Ad</Label><Input id="pf-first" value={form.first} onChange={set('first')} className="mt-1" data-testid="profile-first-name-input" /></div>
        <div><Label htmlFor="pf-last">Soyad</Label><Input id="pf-last" value={form.last} onChange={set('last')} className="mt-1" data-testid="profile-last-name-input" /></div>
        <div><Label htmlFor="pf-email">E-posta</Label><Input id="pf-email" type="email" value={form.email} onChange={set('email')} className="mt-1" data-testid="profile-email-input" />
          <EmailCheckHint state={emailCheck} testId="profile-email-check" />
          <p className="mt-1 text-xs text-slate-500">Giriş için de bu adres kullanılır.</p></div>
        <div><Label htmlFor="pf-phone">Telefon <span className="text-xs text-slate-400">(opsiyonel)</span></Label><Input id="pf-phone" type="tel" value={form.phone} onChange={set('phone')} placeholder="05xx xxx xx xx" className="mt-1" data-testid="profile-phone-input" /></div>
      </div>
      <div className="flex gap-2">
        <Button type="submit" disabled={saving || emailCheck.status === 'taken'} className="bg-emerald-600 text-white hover:bg-emerald-700" data-testid="profile-save-btn">
          {saving ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Save className="mr-1 h-4 w-4" />}Kaydet
        </Button>
        <Button type="button" variant="outline" onClick={onClose} disabled={saving} data-testid="profile-cancel-btn"><X className="mr-1 h-4 w-4" />Vazgeç</Button>
      </div>
    </form>
  );
};

export const ProfileEditButton = ({ onClick }) => (
  <Button variant="outline" size="sm" onClick={onClick} className="ml-auto" data-testid="profile-edit-btn"><Pencil className="mr-1 h-4 w-4" />Düzenle</Button>
);
